import ResetPasswordModal from './ResetPasswordModal';

export default ResetPasswordModal;



// WEBPACK FOOTER //
// ./src/components/ResetPasswordModal/index.js